import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import StoresPreview from "./pages/StoresPreview";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Auth from "./pages/Auth";
import Home from "./pages/Home";
import AdminDashboard from "./pages/AdminDashboard";
import ScanQR from "./pages/ScanQR";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SubscriptionRequired from "./components/SubscriptionRequired";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import AdminRoute from "./components/AdminRoute";
import RequireSubscription from "./components/RequireSubscription";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/stores-preview" element={<StoresPreview />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/scan" element={<ScanQR />} />
          
          {/* Rutas públicas (redirigen a /home si ya está logueado) */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Auth mode="login" />
              </PublicRoute>
            } 
          />
          <Route 
            path="/signup" 
            element={
              <PublicRoute>
                <Auth mode="signup" />
              </PublicRoute>
            } 
          />
          <Route 
            path="/forgot-password" 
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            } 
          />
          <Route 
            path="/reset-password" 
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            } 
          />
          
          {/* Ruta de suscripción/pago (requiere autenticación pero NO suscripción activa) */}
          <Route 
            path="/subscription" 
            element={
              <ProtectedRoute>
                <SubscriptionRequired />
              </ProtectedRoute>
            } 
          />
          
          {/* Rutas protegidas (requieren autenticación + suscripción activa) */}
          <Route 
            path="/home" 
            element={
              <ProtectedRoute>
                <RequireSubscription>
                  <Home />
                </RequireSubscription>
              </ProtectedRoute>
            } 
          />
          
          {/* Ruta admin (requiere autenticación + rol admin) */}
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
